import { memo } from 'react';
import { range } from '@repo/util/range';

export interface SkeletonProps {
  count?: number;
  height?: string;
  gap?: string;
}

export const Skeleton = memo(function Skeleton({ count = 1, height }: SkeletonProps) {
  return (
    <div className="flex flex-col w-full gap-2">
      {range(count, (index) => (
        <div className="flex items-center w-full h-full animate-pulse" key={index + 1}>
          <div className="w-full h-4 rounded bg-grey-400 dark:bg-grey-800" style={{ height }} />
        </div>
      ))}
    </div>
  );
});
